const SUBSCRIPTION_VARIANTS = [
  { subscription: 'studioAi', variant: 'studio_ai' },
  { subscription: 'studioUnlimited', variant: 'studio_unlimited' },
  { subscription: 'allAccess', variant: 'all_access' },
] as const

type Subscription = (typeof SUBSCRIPTION_VARIANTS)[number]['subscription']

type UndoCancellationVariant = (typeof SUBSCRIPTION_VARIANTS)[number]['variant']

export interface UndoCancellationBannerData {
  variant: UndoCancellationVariant
  subscriptionId: string
}

interface UndoCancellationBannerQueryInput {
  isAuthPending: boolean
  isLoggedIn: boolean
  isSiteDataPending: boolean
  isSubscriptionIdsPending: boolean
  pendingCancelSubscriptionId: string | undefined
  subscriptionIds: Record<Subscription, string | undefined> | undefined
}

export function resolveUndoCancellationBannerQuery({
  isAuthPending,
  isLoggedIn,
  isSiteDataPending,
  isSubscriptionIdsPending,
  pendingCancelSubscriptionId,
  subscriptionIds,
}: UndoCancellationBannerQueryInput) {
  return {
    isPending: isAuthPending || (isLoggedIn && (isSiteDataPending || isSubscriptionIdsPending)),
    data: findBannerData(pendingCancelSubscriptionId, subscriptionIds),
  }
}

function findBannerData(
  pendingCancelSubscriptionId: string | undefined,
  subscriptionIds: UndoCancellationBannerQueryInput['subscriptionIds'],
): UndoCancellationBannerData | undefined {
  if (!pendingCancelSubscriptionId || !subscriptionIds) {
    return undefined
  }

  const match = SUBSCRIPTION_VARIANTS.find(
    ({ subscription }) => subscriptionIds[subscription] === pendingCancelSubscriptionId,
  )

  return match ? { variant: match.variant, subscriptionId: pendingCancelSubscriptionId } : undefined
}
